import {
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Input,
  message,
  Row,
  Select,
  Table,
  Typography,
} from "antd";
import React from "react";
import {
  PromotionConst,
  PromotionValueModel,
} from "shared/models/promotion.model";
import { BranchModel } from "states/branch/branch.models";
import {
  LogicalTermEnum,
  ProductCategoryModel,
} from "states/product-category/product-category.models";
import { PromotionCodeModel } from "states/promotion-code/promotion-code.models";

import { PromotionProductTransferComponent } from "./promotion-products-transfer-component";

export interface IPromotionCodeValueTabProps {
  model: PromotionCodeModel;
  onChange: (newModel: PromotionCodeModel) => void;
  isUpdateMode: boolean;
  categories: ProductCategoryModel[];
  currentTimeZone: string;
}

export function PromotionCodeValueTab(props: IPromotionCodeValueTabProps) {
  const { model, onChange, isUpdateMode, categories, currentTimeZone } = props;
  const getModelTemp = () => {
    return { ...model };
  };
  const getValue = () => {
    let model = getModelTemp();
    if (model.promotion.values.length === 0) {
      model.promotion.values.push({
        type: PromotionConst.promotionValueType.discount,
        discountValue: 0,
        logicType: LogicalTermEnum.Or,
        maximumAmountValue: 0,
        productIds: [],
        discountType: PromotionConst.discountType.amount,
        numberOfGifts: 1,
      } as PromotionValueModel);
      onChange(model);
    }
    return model.promotion.values[0];
  };

  const handleChange = (productIds: number[]) => {
    let model = getModelTemp();
    model.promotion.values[0].productIds = productIds;
    onChange(model);
  };
  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span="8">
          <Collapse defaultActiveKey={["1"]} className="mb-4">
            <Collapse.Panel key="1" header="Loại khuyến mãi" className="mb-4">
              <Input.Group className="mb-4">
                <Typography.Text>Loại khuyến mãi </Typography.Text>
                <Select
                  className="w-100"
                  placeholder="Chọn loại khuyến mãi"
                  allowClear
                  showSearch
                  value={getValue()?.type}
                  filterOption={(input, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(value: string) => {
                    let model = getModelTemp();
                    model.promotion.values[0].type = value;
                    model.promotion.values[0].productIds = [];
                    onChange(model);
                  }}
                >
                  <Select.Option
                    value={PromotionConst.promotionValueType.discount}
                  >
                    Giảm giá
                  </Select.Option>
                  {/* <Select.Option value={PromotionConst.promotionValueType.gift}>
                    Gift
                  </Select.Option> */}
                </Select>
              </Input.Group>
            </Collapse.Panel>
          </Collapse>
        </Col>
        {getValue()?.type === PromotionConst.promotionValueType.discount && (
          <Col span="16">
            <Collapse defaultActiveKey={["1"]} className="mb-4">
              <Collapse.Panel key="1" header="Giảm giá" className="mb-4">
                <Input.Group className="mb-4">
                  <Typography.Text>Loại giảm giá </Typography.Text>
                  <Select
                    className="w-100"
                    placeholder="Chọn loại giảm giá"
                    allowClear
                    showSearch
                    value={getValue()?.discountType}
                    filterOption={(input, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(value: string) => {
                      let model = getModelTemp();
                      model.promotion.values[0].discountType = value;
                      onChange(model);
                    }}
                  >
                    <Select.Option value={PromotionConst.discountType.amount}>
                      Số tiền
                    </Select.Option>
                    <Select.Option value={PromotionConst.discountType.percent}>
                      Phần trăm
                    </Select.Option>
                  </Select>
                </Input.Group>
                <Input.Group>
                  <Typography.Text>Giá trị </Typography.Text>
                  <Input
                    value={getValue()?.discountValue}
                    onChange={(e) => {
                      let model = getModelTemp();
                      model.promotion.values[0].discountValue =
                        e.target.valueAsNumber;
                      onChange(model);
                    }}
                    type="number"
                    placeholder="Giá trị"
                  ></Input>
                </Input.Group>
              </Collapse.Panel>
            </Collapse>
          </Col>
        )}
      </Row>
      {getValue()?.type === PromotionConst.promotionValueType.gift && (
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Collapse defaultActiveKey={["1"]}>
              <Collapse.Panel key="1" header="Quà tặng">
                <Input.Group className="mb-4">
                  <Typography.Text>Số lượng quà tặng: </Typography.Text>
                  <Input
                    value={getValue()?.numberOfGifts}
                    onChange={(e) => {
                      let model = getModelTemp();
                      model.promotion.values[0].numberOfGifts = Number(
                        e.target.value
                      );
                      onChange(model);
                    }}
                    placeholder="Số lượng quà tặng"
                  ></Input>
                </Input.Group>
                <PromotionProductTransferComponent
                  productIds={getValue()?.productIds ?? []}
                  onChange={(productIds: number[]) => {
                    handleChange(productIds);
                  }}
                  currentTimeZone={currentTimeZone}
                  categories={categories}
                />
              </Collapse.Panel>
            </Collapse>
          </Col>
        </Row>
      )}
    </div>
  );
}
